/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { OralExamCurrentQuestionAnswerKey } from './oralExamCurrentQuestionAnswerKey';

/**
 * Resolved question shown to lecturer and student during the exam.
 */
export interface OralExamCurrentQuestion {
  questionId: string;
  question: string;
  answerKey?: OralExamCurrentQuestionAnswerKey;
}
